import { ConfigPedidoProps } from '../types';

import { usePedidoCompraContext } from 'context/PedidoCompraContext';

export function useFrete() {
    const { vlPedido, usuarioInfo, configPedido } = usePedidoCompraContext();
    const { configPedidoRegraValidacao } = (configPedido || {}) as ConfigPedidoProps;
    const { vlBaseFreteGratis } = configPedidoRegraValidacao || {};
    const hasVlFrete = typeof usuarioInfo?.vlFrete === 'number';
    const hasVlBaseFreteGratis = typeof vlBaseFreteGratis === 'number';

    let vlParaFreteGratis = 0;
    let vlFrete = 0;
    let progressFrete: number | undefined = undefined;

    if (hasVlBaseFreteGratis && vlBaseFreteGratis > vlPedido) {
        vlParaFreteGratis = vlBaseFreteGratis - vlPedido;
    }

    if (hasVlFrete && (!hasVlBaseFreteGratis || vlParaFreteGratis)) {
        vlFrete = usuarioInfo?.vlFrete;
    }

    if (hasVlBaseFreteGratis && hasVlFrete) {
        progressFrete = (vlPedido / vlBaseFreteGratis) * 100;
    }

    return {
        vlFrete,
        vlPedido,
        hasVlFrete,
        progressFrete,
        vlParaFreteGratis,
        isFreteGratis: vlFrete === 0,
        hasFreteSection: hasVlFrete && hasVlBaseFreteGratis,
        vlBaseFreteGratis: hasVlBaseFreteGratis ? vlBaseFreteGratis : undefined,
    };
}
